export enum PostingStatus {
  SUSPENDED = 'suspended',
  ACTIVE = 'active',
  DRAFT = 'draft',
  CLOSED = 'closed',
}
